module.exports = __webpack_public_path__ + "static/media/chomp.cd06c2fb.mp3";